import { z } from 'zod'

/**
 * A definition of an ideal customer profile. The attributes are all (deeply) optional since firecrawl does not always
 * succeeds in populating all of them.
 */
export const ShopIcp = z.object({
  demographics: z
    .object({
      age: z
        .object({
          min: z.number().optional(),
          max: z.number().optional(),
        })
        .optional(),
      gender: z.string().optional(),
      income: z
        .object({
          min: z.number().optional(),
          max: z.number().optional(),
        })
        .optional(),
      education: z.string().optional(),
      occupation: z.string().optional(),
      location: z.string().optional(),
    })
    .optional(),
  psychographics: z
    .object({
      hobbiesAndInterests: z.string().optional(),
      lifestyle: z.string().optional(),
      values: z.string().optional(),
    })
    .optional(),
})

export type ShopIcp = z.infer<typeof ShopIcp>
